import LiquidityRequestPage from "./LiquidityRequestPage";

export default LiquidityRequestPage;
